import PropTypes from 'prop-types';
import { Link } from 'gatsby-plugin-react-i18next';
import { renderRichText } from 'gatsby-source-contentful/rich-text';
import { BLOCKS } from '@contentful/rich-text-types';

import ImageDisplay from '../imageDisplay';
import PageLink from '../pageLink';

const YEAR_TOKEN = '%year%';

const LegalStatement = ({ content }) => {
	// Replace the token for the current year.
	const parsedContent = {
		...content,
		raw: content.raw.replace(YEAR_TOKEN, new Date().getFullYear().toString()),
	};
	const options = {
		renderNode: {
			[BLOCKS.PARAGRAPH]: (node, children) => (
				<p
					className={`typography typography--body-small typography--grayscale-40 ${
						children.every((child) => typeof child === 'string') &&
						'footer__legal-statement'
					}`}
				>
					{children}
				</p>
			),
			hyperlink: (node, children) => (
				<Link className="footer__legal-link" to={`${node?.data?.uri}/`}>
					{children}
				</Link>
			),
		},
	};

	return renderRichText(parsedContent, options);
};

const Footer = ({ logo, links: linkSections, cta, legalStatement }) => {
	return (
		<footer role="contentinfo" className="footer bg--tertiary">
			<div className="footer__content">
				<div className="footer__logo">
					<div>
						<ImageDisplay
							data={logo?.gatsbyImageData}
							src={logo?.file?.url}
							alt={logo?.description}
						/>
					</div>
					<a
						href={cta?.link}
						className="btn btn--white"
						target="_blank"
						rel="noreferrer"
					>
						{cta?.title}
					</a>
				</div>
				<div className="footer__sections">
					{linkSections.map(({ id, linkTitle, links }) => (
						<div key={id} className="footer__section">
							{linkTitle && (
								<h3 className="footer__section-title typography typography--h5 typography--white">
									{linkTitle}
								</h3>
							)}
							{links.map(({ id, linkLabel, linkDestination }) => (
								<PageLink
									key={id}
									className="footer__section-link typography typography--body typography--white"
									to={linkDestination}
								>
									{linkLabel}
								</PageLink>
							))}
						</div>
					))}
				</div>
				{legalStatement && (
					<div className="footer__legal">
						<LegalStatement content={legalStatement} />
					</div>
				)}
			</div>
		</footer>
	);
};

Footer.propTypes = {
	logo: PropTypes.shape({
		description: PropTypes.string.isRequired,
		file: PropTypes.object.isRequired,
		gatsbyImageData: PropTypes.object,
	}).isRequired,
	links: PropTypes.arrayOf(PropTypes.object),
	cta: PropTypes.shape({
		title: PropTypes.string.isRequired,
		link: PropTypes.string.isRequired,
	}).isRequired,
	legalStatement: PropTypes.shape({
		raw: PropTypes.string,
	}),
};

Footer.defaultProps = {
	links: [],
	legalStatement: null,
};

export default Footer;
